// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2LS2f","inputWrap":"CustomTip_inputWrap__1I4G-"};